var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4152_111711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7.00021C14 3.13388 10.866 0.00012207 7.00011 0.00012207C3.13404 0.00012207 0 3.13388 0 7.00021C0 10.8659 3.13404 14 7.00011 14C10.866 14 14 10.8659 14 7.00021Z",
    fill: "#25B7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.895 10.1456C8.85586 10.0882 8.78078 10.0678 8.71808 10.0975C8.02445 10.4259 7.2372 10.7731 7.08269 10.8034C7.07879 10.7999 7.07261 10.7936 7.06452 10.7826C7.04358 10.7542 7.03339 10.7172 7.03339 10.6693C7.03339 10.2769 7.32953 9.08337 7.91353 7.12191C8.40594 5.47388 8.46289 5.13265 8.46289 5.01936C8.46289 4.84447 8.39593 4.6967 8.26918 4.59199C8.14878 4.49269 7.98055 4.44238 7.7692 4.44238C7.41765 4.44238 7.0102 4.57585 6.52354 4.85043C6.05196 5.1166 5.52602 5.56742 4.96044 6.19036C4.91617 6.23915 4.91155 6.31209 4.9493 6.36609C4.98711 6.42013 5.05723 6.4407 5.1182 6.41587C5.31677 6.33483 6.31465 5.92605 6.46011 5.83469C6.57922 5.76002 6.68232 5.72213 6.76657 5.72213C6.76959 5.72213 6.77219 5.72224 6.77436 5.72241C6.77538 5.728 6.77634 5.73652 6.77634 5.74874C6.77634 5.83471 6.75865 5.93649 6.72397 6.05074C5.87363 8.80586 5.46028 10.4948 5.46028 11.2142C5.46028 11.4681 5.53085 11.6725 5.66998 11.8217C5.81177 11.9739 6.00303 12.051 6.23844 12.051C6.48932 12.051 6.79465 11.9462 7.17185 11.7306C7.53687 11.5221 8.09398 11.0632 8.87511 10.3278C8.9257 10.2802 8.93413 10.2029 8.895 10.1456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86801 2.16346C8.72905 2.02122 8.55122 1.9491 8.33954 1.9491C8.076 1.9491 7.84645 2.05324 7.65737 2.25866C7.47131 2.4607 7.37695 2.70861 7.37695 2.99549C7.37695 3.22215 7.44645 3.40999 7.5835 3.55376C7.72238 3.6997 7.89781 3.77368 8.10483 3.77368C8.3576 3.77368 8.5859 3.66369 8.78336 3.44676C8.97738 3.23364 9.07577 2.98307 9.07577 2.70203C9.0758 2.48606 9.00591 2.30488 8.86801 2.16346Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4152_111711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.c5391964f5b4f6ffda506d047de41bb9.svg";
export { ForwardRef as ReactComponent };